import http from '@plugin/axios'

function getlist(list: any[] = []) {
  return Object.freeze(list)
}

export default async function getData(params: any) {
  const info = await http<any>({
    url: '/srmPurchaseHead/getSrmPurchaseHeadPageByParams',
    baseURL: process.env.VUE_APP_PURCHASE_API,
    data: params
  })

  const list: any[] = await http({
    url: '/srmPurchaseSchedule/getSrmPurchaseScheduleList',
    baseURL: process.env.VUE_APP_PURCHASE_API,
    data: { purchaseNos: info.records.map((i: any) => i.purchaseNo).join(','), status: params.condition.status }
  })
  return {
    ...info,
    records: Object.freeze(info.records.map((item: any, index: number) => {
      return {
        ...item,
        list: getlist(list[index] && list[index].list)
      }
    }))
  }
}
